import { getBaseInfoP, getJourneyP, queryPlaneInfoP, getCoronaviruP } from 'create-api';
import * as types from '../mutation-types';

// initial state
const state = {
    baseInfo: undefined,
    journeyId: undefined,
    planeInfo: null,
    departCityCode: null,
    departCityName: null,
    realDepartCityList: null
};

// getters
const getters = {
    productId: state => state.baseInfo && state.baseInfo.productId,
    isApp: state => state.baseInfo && state.baseInfo.isApp,
    createGroupType: state => state.baseInfo && state.baseInfo.productDetail && state.baseInfo.productDetail.createGroupType,
    recommendCity: state => {
        let departCity = state.baseInfo && state.baseInfo.otherInfo && state.baseInfo.otherInfo.departCity || {};
        return {
            cityCode: departCity.recommendDepartCityCode,
            cityName: departCity.recommendDepartCityName
        }
    }
};

// actions
const actions = {
    resetBaseInfo ({ commit }) {
        commit(types.RESET_PRODUCT_INFO);
    },
    getBaseInfo ({ commit }, { productId, cookies, userAgent }) {
        return getBaseInfoP({
            productId
        }, cookies, userAgent).then(data => {
            if (data && data.productId) {
                if (data.head.saleEmpty === 1) {
                    data.status = 1;
                }
                commit(types.RECEIVE_PRODUCT_INFO, { baseInfo: data });
                return new Promise(function (resolve, reject) {
                    resolve(data);
                });
            } else {
                commit(types.RECEIVE_PRODUCT_INFO, { baseInfo: {} });
            }
        }).catch(err => {
            console.error(err);
        });
    },
    addFavorite ({ commit }) {
        commit(types.ADD_FAVORITE);
    },
    deleteFavorite ({ commit }) {
        commit(types.DELETE_FAVORITE);
    },
    getJourneyInfo({ commit }, { productId, journeyId }) {
        return getJourneyP({
            productId,
            journeyId
        }).then(data => {
            if (data && data.journeyDetail) {
                commit(types.CHANGE_JOURNEYID, {journeyId})
                commit(types.ADD_JOURNEY_DATA, {journeyDetail: data.journeyDetail});
                return new Promise(function (resolve, reject) {
                    resolve(data);
                });
            }
        }).catch(err => {
            console.error(err);
        });
    },
    changeJourneyId({
        commit,
        state
    }, journeyId) {
        commit(types.CHANGE_JOURNEYID, {journeyId})
    },
    // 查询特价机票
    queryPlaneInfo({ commit }, {destCityCode}) {
        queryPlaneInfoP({ destCityCode}).then(data => {
            if (data) {
                commit(types.QUERY_PLANE_INFO, { data });
                return Promise.resolve();
            }
        }).catch(err => {
            console.error(err);
            return Promise.resolve();
        });
    },
    createBargainOrder ({ commit }, payload) {
        commit(types.CREATE_BARGAIN_FAVORITE, payload);
    },
    // 更改出发城市code
    changeDepartCityCode ({
        commit
    }, departCityCode) {
        commit(types.CHANGE_DEPART_CITY_CODE, {departCityCode})
    },

    // 更改出发城市名称
    changeDepartCityName ({
        commit
    }, departCityName) {
        commit(types.CHANGE_DEPART_CITY_NAME, {departCityName})
    },

    // 更新联运城市真实出发城市列表
    changeRealDepartCityList ({
        commit
    }, realDepartCityList) {
        commit(types.CHANGE_REAL_DEPART_CITY_LIST, {realDepartCityList})
    },

    /**
     * 获取疫情提醒信息
     */
    getCoronaviru({ state, commit }, params) {
        let departCityCode = state.departCityCode;
        return getCoronaviruP({
            productId: params.productId,
            departCityCode: departCityCode || params.bookCityCode || 0
        }).then(res => {
            console.log(res, departCityCode, params.bookCityCode);
            // res = JSON.parse(res);
            // console.log(res);
            if (res && res.success && res.data || {}) {
                commit(types.GET_PRODUCT_INFORMATIONS, res);
                // console.log('GET_PRODUCT_INFORMATIONS   =====> ', res);
                return new Promise(function (resolve, reject) {
                    resolve(res);
                });
            }
        })
        .catch((err) => {
            console.log("error ===> ", err);
        });
    }

};

// mutations
const mutations = {
    [types.RECEIVE_PRODUCT_INFO] (state, payload) {
        if (payload.baseInfo) {
            state.baseInfo = payload.baseInfo;
            if (state.departCityCode === null) {
                // 目的地参团不需要设置
                if (state.baseInfo.data && state.baseInfo.data.productDetail && state.baseInfo.data.productDetail.createGroupType === 2) {
                } else {
                    let departCity = state.baseInfo.otherInfo && state.baseInfo.otherInfo.departCity || {}
                    state.departCityCode = departCity.recommendDepartCityCode || 0
                    state.departCityName = departCity.recommendDepartCityName || '全国'
                    state.realDepartCityList = departCity.realDepartCityList || []
                }
            }
            // state.isApp = payload.baseInfo.isApp;
        }
    },
    [types.RESET_PRODUCT_INFO] (state) {
        state.baseInfo = undefined;
    },
    [types.ADD_FAVORITE] (state) {
        if (state.baseInfo) {
            state.baseInfo.collected = true;
        }
    },
    [types.DELETE_FAVORITE] (state) {
        if (state.baseInfo) {
            state.baseInfo.collected = false;
        }
    },
    [types.ADD_JOURNEY_DATA](state, { journeyDetail }) {
        (state.baseInfo && state.baseInfo.journeyInfos || []).forEach(item => {
            if (item.journeyId === state.journeyId) {
                item.journeyDetail = journeyDetail;
            }
        });
    },
    [types.CHANGE_JOURNEYID](state, {journeyId}) {
        state.journeyId = journeyId;
    },
    [types.QUERY_PLANE_INFO](state, payload) {
        if (payload.data) {
            state.planeInfo = payload.data;
        }
    },
    [types.CREATE_BARGAIN_FAVORITE](state, {peopleCount, priceCount, showStatus, bargainId}) {
        if (state.baseInfo && state.baseInfo.cutPriceActivity) {
            state.baseInfo.cutPriceActivity = Object.assign({}, state.baseInfo.cutPriceActivity, {
                peopleCount,
                priceCount,
                showStatus,
                bargainId
            });
        }
    },
    [types.CHANGE_DEPART_CITY_CODE](state, {departCityCode}) {
        state.departCityCode = departCityCode;
    },
    [types.CHANGE_DEPART_CITY_NAME](state, {departCityName}) {
        state.departCityName = departCityName;
    },
    [types.CHANGE_REAL_DEPART_CITY_LIST](state, {realDepartCityList}) {
        state.realDepartCityList = realDepartCityList;
    },
    [types.GET_PRODUCT_INFORMATIONS] (state, data) {
        state.specialTips = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// libs/store/modules/detail.js